module.exports = __webpack_public_path__ + "static/media/insurance.fc9044c0.svg";